import type { DesignGroup } from '../types/storeReviewOrderStep.types';
import type { ICartItemDetail } from '@/common/interfaces/cart.interface';

export const getDesignGroupLabel = (index: number): string =>
  `Design ${String.fromCharCode(65 + index)}`;

export const reorderDesignGroupsAfterRemoval = (groups: DesignGroup[]): DesignGroup[] =>
  groups.map((group, index) => ({
    ...group,
    name: getDesignGroupLabel(index),
  }));

export const getDesignGroupIdFromGroup = (group: DesignGroup): number | null =>
  group.designGroupId ?? group.items[0]?.designGroupItemId ?? null;

export const getRemainingItemsAfterRemoval = (
  items: ICartItemDetail[],
  removedItemIds: number[]
): ICartItemDetail[] => items.filter((item) => !removedItemIds.includes(item.id));

export const reindexRecordAfterGroupRemoval = <T>(
  record: Record<number, T>,
  removedGroupIndex: number
): Record<number, T> => {
  const next: Record<number, T> = {};
  Object.entries(record).forEach(([key, value]) => {
    const index = Number(key);
    if (index < removedGroupIndex) {
      next[index] = value;
    } else if (index > removedGroupIndex) {
      next[index - 1] = value;
    }
  });
  return next;
};
